import { Injectable } from '@angular/core';
import { ImpactOverlayConfig, OverlayService } from '@libs/overlay';
import { MixedCampaignModel } from '@features/campaigns/campaigns.models';
import { ActiveCampaign } from '@features/product/product.models';
import { ProductActionModel } from '@features/product/product-actions/product-actions';

import { StoreStockContainerComponent } from '@features/store-stock/store-stock-container/store-stock-container.component';
import { StoreStockSidebarType } from '@features/store-stock/store-stock';
import { NotifyMeDialogComponent } from '@shared/notify-me/notify-me-dialog/notify-me-dialog.component';

@Injectable()
export class ProductDialogOverlayService {
    constructor(private readonly overlayService: OverlayService) {}

    /**
     * let's open the campaign overlay but in lazy way to avoid circular dependency and reduce bundle size of the main product module
     * @param line - product line
     * @param storeId - store id
     * @param campaign - active campaign
     */
    public async openCampaignOverlay(line: ProductActionModel, storeId?: string, campaign?: ActiveCampaign) {
        if (!campaign) {
            return;
        }

        const config: ImpactOverlayConfig<MixedCampaignModel> = {
            data: {
                activeCampaign: campaign,
                activeSplashes: line?.activeSplashes || [],
                selectedStoreId: storeId,
                productId: line.variantNo
            }
        };

        const component = await import(
            '@features/campaigns/mixed-campaign-container/mixed-campaign-container.component'
        ).then(r => r.MixedCampaignContainerComponent);

        this.overlayService.open(component, config);
    }

    /**
     * Open stock overlay
     * @param line - product line
     * @param type - stock sidebar type
     */
    public openStockOverlay(line: ProductActionModel, type: StoreStockSidebarType): void {
        this.overlayService.open(StoreStockContainerComponent, {
            data: {
                stockSidebarType: type,
                product: line
            }
        });
    }

    public notifyMe(line: ProductActionModel): void {
        this.overlayService.open(NotifyMeDialogComponent, {
            data: {
                product: line
            }
        });
    }
}
